export function MathRound(number, decimal = 2) {
  if (Number.isNaN(number)) return 0;
  if (Number.isNaN(decimal)) return number;
  const temp = Math.pow(10, decimal);
  return Math.round(number * temp) / temp;
}

function slideLeft(el: Element, distance: number, step = 6) {
  const totalDistance = MathRound(el.scrollLeft + distance, 2);
  let animationHandleId = requestAnimationFrame(
    function slideHorizontalInner() {
      if (MathRound(el.scrollLeft + el.clientWidth, 2) >= el.scrollWidth) {
        cancelAnimationFrame(animationHandleId);
        return;
      }
      if (el.scrollLeft + 1 < totalDistance) {
        const slideDistance = MathRound(
          Math.min(step, MathRound(totalDistance - el.scrollLeft, 2)),
          2,
        );
        el.scrollLeft = MathRound(el.scrollLeft + slideDistance, 2);
        animationHandleId = requestAnimationFrame(slideHorizontalInner);
      } else {
        cancelAnimationFrame(animationHandleId);
      }
    },
  );
}

function slideRight(el: Element, distance: number, step = 6) {
  const totalDistance = MathRound(el.scrollLeft - distance, 2);
  let animationHandleId = requestAnimationFrame(
    function slideHorizontalInner() {
      if (el.scrollLeft <= 0) {
        cancelAnimationFrame(animationHandleId);
        return;
      }
      if (el.scrollLeft > totalDistance) {
        const slideDistance = MathRound(
          Math.min(step, el.scrollLeft - totalDistance),
          2,
        );
        el.scrollLeft = MathRound(el.scrollLeft - slideDistance, 2);
        animationHandleId = requestAnimationFrame(slideHorizontalInner);
      } else {
        cancelAnimationFrame(animationHandleId);
      }
    },
  );
}

export function slideHorizontal(
  el: Element | null,
  distance: number,
  step = 6,
) {
  if (!el) {
    console.error(
      'el is not an valid element passed to the method slideHorizontal',
    );
    return;
  }
  if (distance > 0) {
    slideLeft(el, distance, step);
  } else if (distance < 0) {
    slideRight(el, Math.abs(distance), step);
  }
}

export function slideHorizontalTo(el: Element, x: number, step = 100) {
  if (!el) {
    console.error(
      'el is not an valid element passed to the method slideHorizontalTo',
    );
    return;
  }
  const currentScrollLeft = el.scrollLeft;
  if (currentScrollLeft === x) return;
  
  // 使用 scrollTo 的 smooth 行为替代自定义动画，性能更好
  if ('scrollTo' in el && typeof (el as any).scrollTo === 'function') {
    try {
      (el as any).scrollTo({
        left: x,
        behavior: 'smooth'
      });
      return;
    } catch (e) {
      // 降级到原有动画方式
    }
  }
  
  slideHorizontal(el, x - currentScrollLeft, step);
}
